import { MenuItem, TextField, Typography } from '@mui/material';
import React from "react";
import { ArrowType } from '../../../types';

export default function SelectDefaultEdgeArrows(props) {

  const HandleTypeEdgeChange = (type) => {
    props.handleChange({
      target: {
        name: "edgearrows",
        value: type.target.value
      }
    });
  }

  return (
    <div>
      {props.hideLabel != true &&
        <Typography variant="caption">
          Default arrow preferences for edges.
        </Typography>
      }
      <TextField 
        id="template-style-shape" 
        select 
        label="Arrow type" 
        size="small" 
        margin="dense" 
        defaultValue={props.value} 
        value={props.value} 
        onChange={HandleTypeEdgeChange} 
        sx={{ width: "100%" }}>
        {ArrowType.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
}